import classNames from 'classnames'
import React from 'react'

interface SectionProps {
  className?: string
  children: React.ReactNode
  divider?: boolean
}

export const Section: React.FC<SectionProps> = (props) => {
  const { className, children, divider } = props
  return (
    <div
      className={classNames(className, '', {
        'mb-7 border-b border-common-gray-5 pb-7': divider,
      })}
    >
      {children}
    </div>
  )
}
